import React from 'react';
import { motion } from 'framer-motion';
import { useAppContext } from '../context/AppContext';
import { ProgressBar } from '../components/ProgressBar';
import { Logo } from '../components/Logo';
import { CheckCircle2, Globe, Clock, Shield, Star } from 'lucide-react';
export const Landing = () => {
  const {
    setCurrentPage
  } = useAppContext();
  return <div className="min-h-screen bg-bg pb-16" data-id="element-115">
      <div className="max-w-[720px] mx-auto px-5 pt-6" data-id="element-116">
        {/* Logo */}
        <div className="flex items-center mb-8" data-id="element-117">
          <Logo size="md" data-id="element-118" />
        </div>

        {/* Hero */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} className="text-center pt-8 pb-6" data-id="element-119">
          <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 rounded-full py-1.5 px-4 mb-5" data-id="element-120">
            <span className="relative flex h-2 w-2" data-id="element-121">
              <span className="absolute inline-flex h-full w-full rounded-full bg-primary opacity-75 animate-ping" data-id="element-122"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" data-id="element-123"></span>
            </span>
            <span className="text-[11px] sm:text-[12px] font-semibold tracking-[0.12em] uppercase text-primary" data-id="element-124">
              Test exclusivo · Alumnos Latinoamérica
            </span>
          </div>

          <h1 className="text-[30px] sm:text-[44px] font-extrabold text-dark leading-[1.1] mb-4 tracking-tight" data-id="element-125">
            Descubre{' '}
            <span className="text-primary" data-id="element-126">cuánto podrías estar ganando</span>{' '}
            si dominaras la IA en gestión de proyectos
            <span className="block text-textlight font-medium text-[17px] sm:text-[20px] mt-4 tracking-[-0.01em] leading-snug" data-id="element-127">
              Haz el test en{' '}
              <span className="text-dark font-semibold" data-id="element-128">2 minutos</span> y
              averígualo.
            </span>
          </h1>

          <p className="text-[17px] sm:text-[19px] text-textlight leading-[1.55] mb-8 max-w-[560px] mx-auto font-normal tracking-[-0.005em]" data-id="element-129">
            Responde 15 preguntas rápidas y descubre tu nivel real, tus brechas
            críticas y tu plan personalizado para certificarte con{' '}
            <strong className="text-dark font-semibold" data-id="element-130">
              reconocimiento europeo oficial.
            </strong>
          </p>

          <ul className="text-left max-w-[480px] mx-auto mb-7 space-y-2.5" data-id="element-131">
            {[{
            emoji: '🎯',
            text: 'Dónde estás HOY frente a Project Managers que ya dominan la IA'
          }, {
            emoji: '⏰',
            text: 'Cuántas horas — y cuánto dinero — pierdes cada semana sin saberlo'
          }, {
            emoji: '🛠️',
            text: 'Las herramientas exactas (ChatGPT, Notion, JIRA, Power BI) que multiplicarán tu productividad'
          }, {
            emoji: '🏅',
            text: 'Si calificas para el Certificado Europeo Oficial que abrirá puertas en LinkedIn'
          }, {
            emoji: '🚀',
            text: 'Tu plan personalizado de 90 días para transformar tu carrera o negocio'
          }].map((item, i) => <li key={i} className="flex items-start gap-3 text-[15px] text-text py-1 leading-[1.5]" data-id="element-132">
                <span className="shrink-0 text-[18px] mt-0.5" data-id="element-133">
                  {item.emoji}
                </span>
                <span data-id="element-134">{item.text}</span>
              </li>)}
          </ul>

          <div className="mb-6" data-id="element-135">
            <ProgressBar current={0} total={15} label="Pregunta 1 de 15 — Tiempo estimado: 2 minutos" data-id="element-136" />
          </div>

          <button onClick={() => setCurrentPage('quiz')} className="bg-primary hover:bg-primary-hover text-white border-none rounded-xl py-4 px-8 text-[17px] font-bold cursor-pointer w-full max-w-[480px] mx-auto block transition-all duration-200 shadow-primary hover:-translate-y-0.5 hover:shadow-primary-lg" data-id="element-137">
            👉 COMENZAR MI TEST GRATUITO AHORA
          </button>

          <p className="text-[12px] text-textlight text-center mt-2.5" data-id="element-138">
            🔒 100% Gratuito · Sin tarjeta · Sin compromiso
          </p>
        </motion.div>

        {/* Trust Badges */}
        <div className="flex justify-center gap-2 flex-wrap my-6" data-id="element-139">
          <div className="bg-surface rounded-xl py-2.5 px-3.5 text-center text-[12px] text-textlight flex-1 min-w-[70px] max-w-[120px]" data-id="element-140">
            <span className="text-[22px] block mb-1" data-id="element-141">🎓</span>Certificado
            Europeo Oficial
          </div>
          <div className="bg-surface rounded-xl py-2.5 px-3.5 text-center text-[12px] text-textlight flex-1 min-w-[70px] max-w-[120px]" data-id="element-142">
            <span className="text-[22px] block mb-1" data-id="element-143">🌍</span>Válido en 40+
            países
          </div>
          <div className="bg-surface rounded-xl py-2.5 px-3.5 text-center text-[12px] text-textlight flex-1 min-w-[70px] max-w-[120px]" data-id="element-144">
            <span className="text-[22px] block mb-1" data-id="element-145">⏱️</span>Solo 2 minutos
          </div>
          <div className="bg-surface rounded-xl py-2.5 px-3.5 text-center text-[12px] text-textlight flex-1 min-w-[70px] max-w-[120px]" data-id="element-146">
            <span className="text-[22px] block mb-1" data-id="element-147">🔒</span>100% Seguro
          </div>
        </div>

        {/* Testimonial */}
        <div className="bg-surface rounded-xl p-5 border-l-4 border-primary text-left mt-2" data-id="element-148">
          <div className="text-gold text-[16px] mb-2" data-id="element-149">⭐⭐⭐⭐⭐</div>
          <p className="text-[14px] text-text leading-[1.6] italic" data-id="element-150">
            "Nunca imaginé que un test de 2 minutos me mostraría exactamente por
            qué estaba perdiendo 8 horas semanales. El plan que me dieron cambió
            todo."
          </p>
          <div className="text-[13px] text-textlight mt-2.5 font-semibold" data-id="element-151">
            — Carlos M., Project Manager · Bogotá, Colombia
          </div>
        </div>
      </div>

      <div className="bg-surface p-5 text-center text-[12px] text-textlight border-t border-border mt-10" data-id="element-152">
        © 2026 AIN Academy · Todos los derechos reservados ·
        <a href="#" className="text-textlight ml-1" data-id="element-153">
          Privacidad
        </a>{' '}
        ·
        <a href="#" className="text-textlight ml-1" data-id="element-154">
          Términos
        </a>
      </div>
    </div>;
};